import { type ComponentType, createElement } from 'react'
import type { match, RouteProps } from 'react-router'
import { matchPath } from 'react-router'
import { Route, Switch as RouterSwitch, useLocation } from 'react-router-dom'
import type { SwitchProps } from 'react-router-dom'
import UrlLocation from 'src/lib/url/UrlLocation'

const RouteWithComputedMatch = Route as ComponentType<RouteProps & {
  computedMatch?: match | null
}>

function useLocationWithoutLocale() {
  const location = useLocation()
  const pathWithoutLocale = UrlLocation.fromLocation(location).withoutLocale().path

  return { location, pathWithoutLocale }
}

export function LocaleAwareSwitch(props: SwitchProps) {
  const { location, pathWithoutLocale } = useLocationWithoutLocale()

  return <RouterSwitch {...props} location={{ ...location, pathname: pathWithoutLocale }} />
}

export default function LocaleAwareRoute(props: RouteProps) {
  const { location, pathWithoutLocale } = useLocationWithoutLocale()
  const computedMatch = props.path ? matchPath(pathWithoutLocale, props) : undefined

  return createElement(RouteWithComputedMatch, {
    ...props,
    location,
    computedMatch,
  })
}
